<template>
  <div>
    <v-switch
      v-if="entity.id"
      v-model="newPass"
      label="Atualizar senha"
    />
    <div v-if="newPass || force">
      <validation-provider
        name="nova senha"
        :rules="{
          required: newPass,
          verify_password: true,
        }"
        v-slot="{ errors }"
      >
        <v-text-field
          :append-icon="
            visible ? 'visibility' : 'visibility_off'
          "
          :type="visible ? 'text' : 'password'"
          @click:append="visible = !visible"
          v-model="entity.password"
          :error-messages="errors[0]"
          label="Nova senha"
        />
      </validation-provider>
      <validation-provider
        name="confirmacao de senha"
        :rules="{
          required: (newPass || force) && !!entity.password,
          password: 'nova senha',
          min: 8,
          max: 32,
        }"
        v-slot="{ errors }"
      >
        <v-text-field
          :type="visible ? 'text' : 'password'"
          v-model="confirmation"
          :error-messages="errors[0]"
          label="Confirmação de senha"
        />
      </validation-provider>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
export default {
  props: {
    entity: {
      type: Object,
      required: true
    },
    force: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      confirmation: '',
      visible: false,
      newPass: false
    }
  },
  components: {
    ValidationProvider
  },
  watch: {
    newPass: {
      deep: true,
      handler: function (val) {
        if (val) {
          const { password, ...data } = this.entity
          return this.$emit('update:entity', data)
        }
      }
    }
  }
}
</script>
